import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { TextControl } from '../InputControls';
import { makeRequest, validateEmail } from '../../utils';
import CartIcon from '../../icons/cart';
import AddToCart from '../AddToCart';
import ReadMore from '../ReadMore';

export default function AboutPage() {
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState('');

  document.title = `Series One | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `First series includes books by John Ashbery, Cookie Mueller, Eileen Myles, René Daumal, Max Beckmann, and Dodie Bellamy`);


  return (
    <div className=''>

      <div className='booksPage'>

        <h5>Series I</h5>
        <p className='seriesGraf'>Our debut series pays homage to the editors and contributors of Hanuman Books, from 1986 to 1993, comprising six reissued volumes by John Ashbery, Cookie Mueller, Eileen Myles, Dodie Bellamy, René Daumal, and Max Beckmann as a dedication to the original project.</p>
        <ReadMore>
          <p><strong>Design Note</strong></p>
          <br />
          <p>
            The palette for Series I calls on Nicolas De Staël’s masterpiece, <em>Parc des Princes</em> (1952), shown in his recent retrospective at the Musée d'Art Moderne de Paris, in which De Staël lyrically suggests the vivid atmosphere of a sports match, portraying the “soaring bodies and bright stadium” with nods to compositions by Old Masters such as Uccello. We weave the painting into Hanuman’s design as an inherently avant-garde exercise, a burst of the modern in dialogue with the art of the past.
          </p>
        </ReadMore>
        <div className='gridThree'>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/on-my-painting-max-beckmann' className='gridThree_bookCover' style={{
                background: `url(../../Series-One/MaxBeckman_Mockup2.webp) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>
              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>On My Painting</div>
                <div className='nb-author'>Max Beckmann</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798989378005'} text={'Add to Cart'} />
              </div>
            </div>
          </div>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/the-ice-storm-john-ashbery' className='gridThree_bookCover' style={{
                background: `url(../../Series-One/Ashbery_Side.png) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>The Ice Storm</div>
                <div className='nb-author'>John Ashbery</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798989378012'} text={'Add to Cart'} />
              </div>
            </div>
          </div>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/feminine-hijinx-dodie-bellamy' className='gridThree_bookCover' style={{
                background: `url(../../Series-One/DodieBellamy_Mockup2.webp) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Feminine Hijinx</div>
                <div className='nb-author'>Dodie Bellamy</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798989378029'} text={'Add to Cart'} />
              </div>
            </div>
          </div>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/garden-of-ashes-cookie-mueller' className='gridThree_bookCover' style={{
                background: `url(../../Series-One/Garden_Side.png) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>
              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Garden of Ashes</div>
                <div className='nb-author'>Cookie Mueller</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798989378036'} text={'Add to Cart'} />
              </div>
            </div>
          </div>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/bread-and-water-eileen-myles' className='gridThree_bookCover' style={{
                background: `url(../../Series-One/B-w_Side.png) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Bread and Water</div>
                <div className='nb-author'>Eileen Myles</div>
              </div>
              <div>
                <AddToCart context='landing' id={'9798989378043'} />
              </div>
            </div>
          </div>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/the-lie-of-the-truth-rene-daumal' className='gridThree_bookCover' style={{
                background: `url(../../Series-One/ReneDaumal_Mockup2.webp) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>The Lie of the Truth</div>
                <div className='nb-author'>René Daumal</div>
              </div>
              <div>
                <AddToCart context='landing' id={'9798989378050'} />
              </div>
            </div>
          </div>
        </div>


        <div className='boxGrid'>
          <div className='boxGrid_item'>
            <div className='boxGrid_image'>
              <div className='boxGrid_graphic' style={{ backgroundImage: `url(../../Boxsets/Series_1_Multiview_Boxset_AzureBlue.png)` }}></div>
            </div>
            <div className='boxGrid_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Series 1 Box Set</div>
                <div className='nb-author'>Azure Blue</div>
              </div>
              <div>
                <AddToCart context='landing' id={'hanuman_box_01_az'} />
              </div>
            </div>
          </div>
          <div className='boxGrid_item'>
            <div className='boxGrid_image'>
              <div className='boxGrid_graphic' style={{ backgroundImage: `url(../../Boxsets/Series_1_Multiview_Boxset_Emerald.png)` }}></div>
            </div>
            <div className='boxGrid_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Series 1 Box Set</div>
                <div className='nb-author'>Emerald Green</div>
              </div>
              <div>
                <AddToCart context='landing' id={'hanuman_box_01_em'} />
              </div>
            </div>
          </div>
          <div className='boxGrid_item'>
            <div className='boxGrid_image'>
              <div className='boxGrid_graphic' style={{ backgroundImage: `url(../../Boxsets/Series_1_Multiview_Boxset_Torquoise.png)` }}></div>
            </div>
            <div className='boxGrid_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Series 1 Box Set</div>
                <div className='nb-author'>Turquoise</div>
              </div>
              <div>
                <AddToCart context='landing' id={'hanuman_box_01_tq'} />
              </div>
            </div>
          </div>
          <div className='boxGrid_item'>
            <div className='boxGrid_image'>
              <div className='boxGrid_graphic' style={{ backgroundImage: `url(../../Boxsets/Series_1_Multiview_Boxset_CandyPink.png)` }}></div>
            </div>
            <div className='boxGrid_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Series 1 Box Set</div>
                <div className='nb-author'>Candy Pink</div>
              </div>
              <div>
                <AddToCart context='landing' id={'hanuman_box_01_cp'} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}